import { Component, effect, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { AuthService } from './public/services/auth.service';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [SpinnerComponent, RouterOutlet],
})
export class AppComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  public authStatusChangedEffect = effect(() => {
    console.log(this.authService.authStatus());
    switch (this.authService.authStatus()) {
      case 'checking':
        return;

      case 'authenticated':
        return;

      case 'noAuthenticated':
        this.router.navigateByUrl('/auth/sign-out');
        return;
    }
  });
}
